import axios, { AxiosPromise } from 'axios'
import { ImpressaoEncaminhamentoExternoInput } from 'view/atendimentos/detail/soap/plano/encaminhamento-externo/impressao/ImpressaoEncaminhamentoExternoInput'

export class ImpressaoEncaminhamentoExterno {
  imprimirEncaminhamentoExterno(input: ImpressaoEncaminhamentoExternoInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirEncaminhamentoExterno', input, { responseType: 'blob' })
  }
}
